import React from 'react';
import { observer } from 'mobx-react';

import { ModalContainer, ModalButton, ModalClose, ModalSecondaryHeader, ModalCopy } from 'shared/modals';
import { DELIVERY_ERRORS } from 'shared/constants';
import { useCheckout } from 'checkout/context';
import { openChatWidget } from 'shared/helpers/tools';

const DELIVERY_CUSTOMER_ERROR_TEXT = `Our records show that you've already placed a delivery order with this dispensary today.
  Unfortunately, placing a second delivery order would violate OLCC regulations.
  If you believe this is wrong, please contact support and we'll resolve this immediately!`;

const DELIVERY_ADDRESS_ERROR_TEXT = `Our records show that a delivery has already been made to this address today.
  Unfortunately, placing a second delivery order to this address would violate OLCC regulations.
  If you believe this is wrong, please contact support and we'll resolve this immediately!`;

const ERROR_TEXT_MAP = {
  [DELIVERY_ERRORS.CUSTOMER]: DELIVERY_CUSTOMER_ERROR_TEXT,
  [DELIVERY_ERRORS.ADDRESS]: DELIVERY_ADDRESS_ERROR_TEXT,
};

function DeliveryValidationError() {
  const Checkout = useCheckout();
  const error = Checkout.deliveryValidationError;

  function onClickContactSupport() {
    Checkout.closeDeliveryErrorModal();
    openChatWidget();
  }

  function onRequestClose() {
    Checkout.closeDeliveryErrorModal();
  }

  return (
    <ModalContainer isOpen>
      <ModalSecondaryHeader>Unable to place order</ModalSecondaryHeader>
      <ModalCopy maxWidth={350}>{ERROR_TEXT_MAP[error]}</ModalCopy>
      <ModalButton onClick={onClickContactSupport}>Contact Support</ModalButton>
      <ModalClose onClick={onRequestClose} />
    </ModalContainer>
  );
}

export default observer(DeliveryValidationError);
